export default {
  "ALLTYPES": "ALL TYPES",
  "AccountHierarchySettings": {
    "account": "Account",
    "dialogTitle": "{t} Employee Hierarchy",
    "directSuperiorAccount": "Direct Superior Account",
    "directSuperiorEmail": "Direct Superior Email",
    "directSuperiorName": "Direct Superior Name ",
    "email": "Email",
    "employeeAccount": "Employee Account",
    "employeeName": "Employee Name",
    "isThereASkipLevelLeader": "Is There A Skip Level Leader",
    "name": "Name",
    "no": "No",
    "searchPlaceholder": "Please enter",
    "skipLevelLeaderAccount": "Skip-Level Leader Account",
    "skipLevelLeaderEmail": "Skip-Level Leader Email",
    "skipLevelLeaderName": "Skip-Level Leader Name",
    "yes": "Yes"
  },
  "AddCover": "Add Covers",
  "AddData": "add Data",
  "AddVideo": "Add Images&Video",
  "AddtoEmail": "Add to Email",
  "Admin": {
    "AP": "Active Ratio",
    "AllocateAmount": "Allocate Amount",
    "ArchitectureArea": "ArchitectureArea",
    "BWC": "WeChatID",
    "ManufacturingPlant": "Manufacturing Plant",
    "NOL": "Number of Logins",
    "OFTHEDIV": "Business Unit",
    "OTF": "ArchitectureBelongs",
    "PONo": "PI No.",
    "POSettlement": "Create PI",
    "POType": "PI Type",
    "SAPPI": "SAP PI",
    "SAPStatus": "SAP Status",
    "TL": "Total Accounts",
    "account": "Account",
    "active": "Active",
    "add": "Add",
    "addAccount": "AddAccount",
    "addOnOption": "Add-on Option",
    "addOnOption1": "Add To Purchase List",
    "addRelationship": "New relationship between resignation and inheritance",
    "addtoPo": "Add to PI",
    "all": "All",
    "amountSum": "Amount SUM",
    "amountTotal": "Amount SUM",
    "ariA": "Data inheritance for staff who have resigned",
    "arms": "Arm",
    "arrangementType": "Arrangement Type",
    "authorizedSignature": "Authorized Signature",
    "backs": "Back Cushion",
    "bd": "Affiliation Business Division",
    "businessEmail": "Sales Rep Email",
    "buyer": "Buyer",
    "cabinetType": "Cabinet Type",
    "cancel": "Cancel",
    "categories": "Categories",
    "category": "Category",
    "checkAll": "Check All",
    "china": "China",
    "chinavietnam": "China or Vietnam",
    "cis": "Can Be Send To SAP (YES/NO) ",
    "clear": "Clear",
    "closeAll": "Close All",
    "closeOther": "Close Others",
    "closing": "Closing",
    "code": "Code",
    "color": "Color",
    "completeSetNumber": "Complete Set Number",
    "component": "Component",
    "confirm": "Confirm",
    "confirmDelete": "Confirm Delete?",
    "confirmInheritanceMessage": "Are you sure about the inheritance? Once confirmed, the change cannot be undone.",
    "container": "Container",
    "containerCaculation": "Container Caculation",
    "containerVolumeUtilizationRate": "Container Volume Utilization Rate",
    "content": "Content",
    "continue": "Continue",
    "copy": "Copy",
    "coverGrade": "Cover Grade",
    "createdAccount": "",
    "cube": "Cube",
    "cubeSum": "Cube SUM",
    "cubeTotal": "Cube SUM",
    "cubes": "Cubes",
    "cubesTotal": "Volume Total",
    "customerEmail": "Customer Email",
    "customized": "Customization",
    "deleteInfo": "This operation will permanently delete the file. Do you want to continue?",
    "depth": "Depth",
    "description": "Description",
    "disable": "Disable",
    "discountAmount": "Discount Amount",
    "discountRate": "Discount Rate",
    "edit": "Edit",
    "editAccount": "EditAccount",
    "effective": "Effective",
    "email": "Email",
    "emailEnter": "Separated by semicolons for multiple email addresses.",
    "emailStatus": "Email Status",
    "enable": "Enable",
    "errorInfo": "Fail to delete",
    "exportPO": "Export PI",
    "failToSend": "Fail To Send",
    "fax": "Fax",
    "features": "Product Feature",
    "fp": "Resigned Employee",
    "freight": "Freight",
    "grade": "Grade",
    "group": "Group",
    "height": "Height",
    "image": "Image",
    "inactive": "Inactive",
    "index": "No.",
    "inheritor": "Successor",
    "isUsed": "Is Used",
    "leading": "Leading",
    "leather": "Leather",
    "length": "Length",
    "loadability": "Loading Ability",
    "loginlog": "LoginLog",
    "lwh": "Product Size L*W*H (in)",
    "marketModel": "Market Model",
    "marketNewModel": "Market New Model",
    "material": "Material",
    "mechanisms": "Functional Mech",
    "mes1": "(Note: The successor will inherit the departing person's exhibition customer information, competitor information, hierarchical relationships, etc., and once the data is operated, it cannot be undone.)",
    "mexico": "Mexico",
    "models": "Model",
    "motion": "Function",
    "motionType": "Motion Type",
    "name": "Name",
    "nationality": "Nationality",
    "networkError": "Network error",
    "no": "No",
    "notSigned": "You haven't signed yet, are you sure to submit?",
    "offShelf": "Off Shelf",
    "op": "Operator",
    "ot": "Operation Time",
    "package": "PACKAGING",
    "packageMethod": "PACKAGING",
    "packageSize": "Packaged Size L*W*H (in)",
    "params": "Params",
    "pieceCount": "Piece Count",
    "pleaseEnter": "Please enter",
    "pleaseEnterQTY": "Please Enter Quantity",
    "pleaseSelect": "Please select",
    "pleaseSelectAvaliablePO": "All selected data must be valid",
    "pleaseSelectPO": "Please first check the data to be operated on",
    "poNo": "PI No.",
    "position": "Position",
    "price": "Price",
    "priceRange": "Price Range",
    "promptInfo": "The cubes have achieved to 2200 square feets",
    "provenance": "Provenance",
    "pts": "Attention please ！You can only choose one PI to copy!",
    "qsInventoryAddCarError": "There is no list of styles that can be ordered. Please contact the administrator to update it.",
    "quantityOfGoods": "Quantity Of Goods",
    "rai": "Resignation Succession ",
    "readyDate": "Customer Request Delivery Date",
    "relevantP": "Relevant Personnel",
    "role": "Role",
    "salesDiscount": "Sales Discount",
    "salesPrice": "Sales Price",
    "save": "Save",
    "seats": "Seats",
    "seats2": "Seat Cushion",
    "selectiveColor": "Available Color",
    "sendEmail": "Send Email",
    "sendPo": "Copy PI",
    "sendToSap": "Send To SAP",
    "sent": "Has Been Sent",
    "sentSuccessfully": "Sent Successfully",
    "sentence": "Inconsistent and cannot be created",
    "setQuantity": "Set Quantity",
    "settingUp": "Create",
    "settlementPO": "Create PI",
    "settlementPOTips": "PI Caculation",
    "signatureVerification": "Signature Verification",
    "skin": "Skin",
    "skuType": "SKU Type",
    "spec": "Spec.",
    "status": "Status",
    "styles": "Styles",
    "subtotal": "Subtotal",
    "tips": "Tips",
    "total": "Total",
    "totalCargoVolume": "Total Cargo Volume",
    "totalOrderAmount": "Total Order Amount",
    "trait": "Feature",
    "type": "Type",
    "uniqueArrangment": "Unique Arrangement",
    "unit": "Unit",
    "update": "Update",
    "userAccount": "UserAccount",
    "userCode": "User Code",
    "vietnam": "Vietnam",
    "view": "Preview",
    "weight": "Weight",
    "width": "Width",
    "yes": "Yes"
  },
  "AmountIsNotANumber": "Amount is Not a number or",
  "BatchImport": "Batch import",
  "Brand": "Brand",
  "CatalogPages": "Catalog Pages",
  "ClientName": "Customer Name",
  "Closeup": "Closeup",
  "Commitments": {
    "AddExReservation": "Add ExReservation",
    "AddMarket": "Add Markets",
    "AddNewCustomerData": "Add New Customer Data",
    "AnnualTurnover": "Annual Turnover",
    "ArrangementMaintainTemplate": "Arrangement Maintain template",
    "Arrangements": "Arrangements",
    "BonusMonth": "Bonus Month",
    "Color": "Color",
    "CommitmentConfirm": "Commitment Confirm",
    "CommitmentQTY": "Commitment QTY(ctn)",
    "CommitmentsList": "Commitments list",
    "Company": "Customer Name",
    "Confirm": "Confirm",
    "ConfirmedOrderAMT": "Confirmed Order AMT(USD)",
    "ConfirmedOrderQTY": "Confirmed Order QTY(ctn)",
    "Country": "Country/Area",
    "Covers": "Covers",
    "Customer": "Customer Representitive",
    "CustomerConfirmedDate": "Customer Confirmed Date",
    "CustomerName": "Customer Name",
    "CustomerType": "Customer Type",
    "CustomersToInvite": "Customers To Invite",
    "DescCombination": "Categories",
    "Describe": "Describe",
    "Division": "Division",
    "Edit": "Edit",
    "Email": "Email/Tel",
    "ExhibitionBonusDistributionTemplate": "Exhibition Bonus Distribution Template",
    "ExhibitionBonusStylesTemplate": "Exhibition Bonus Styles Template",
    "IMIC": "Invitation Market Customers Information",
    "IMICT": "Invitation Market Customers Information Template",
    "LineItemNumber": "Line Item Number",
    "MaintainTemplate": "New Model Maintain Template",
    "Maintainer": "Maintainer",
    "MaintenanceDate": "Maintenance Date",
    "Market": "Market",
    "MarketNameCN": "Market Name-CN",
    "MarketNameEN": "Market Name-EN",
    "MarketTime": "Appointment Time",
    "MarketsEndDate": "Markets End Date",
    "MarketsList": "Markets List",
    "MarketsName": "Market Name",
    "MarketsStartDate": "Markets Start Date",
    "MaterialCode": "Material Code",
    "MaterialNumber": "Material Number",
    "Nationality": "Nationality",
    "NewCustomer": "New Customer",
    "NewCustomers": "New Customers",
    "NewModelLaunchDate": "New Model Launch Date",
    "NewModelOrigin": "New Model Origin",
    "NewReGularCustomer": "New/Regular Customer",
    "NumberOfOrders": "QTY(pcs)",
    "OldModelReExhibit": "Old Model Re-Exhibit",
    "OrderAmount": "Order AMT(USD)",
    "OrderCutofftime": "Order Cutoff Date",
    "OrderPlaceDate": "Order Place Date",
    "OverdueDays": "Overdue Days",
    "PODate": "PO Date",
    "POOrderNumber": "PO#",
    "ReasonForNotOrdering": "Reason For Not Ordering",
    "RegularCustomers": "Regular Customers",
    "RequestedReadyDate": "Requested Ready Date",
    "Sales": "Sales",
    "SalesDepartment": "Sales Department",
    "ShippingCutoffTime": "Shipping Cutoff Date",
    "StartDate": "Start Date",
    "StoreNumber": "Store Qty",
    "StyleSpecifications": "Model-Desc.",
    "Title": "Position",
    "TotalAmount": "Total Amount",
    "VPSales": "VP/Sales",
    "ViaitingTimeLately": "Last Customer Visit Date",
    "actualFactoryDate": "Actual Factory Visit Date",
    "actualVisitMarketTime": "Actual Visit Market Time",
    "addAppointment": "Add Appointment",
    "agree": "Agree",
    "appointmentApprovalProcess": "Appointment Approval Process",
    "appointmentList": "Appointment List",
    "approval": "Approval",
    "approvalComments": "Approval Comments",
    "approvalList": "Approval List",
    "approvalStatus": "Approval Status",
    "approved": "Approved",
    "approverComments": "Approver's Comments",
    "area": "Area",
    "clientsToInvite": "Clients To Invite",
    "companyName": "Company Name",
    "countryState": "Country/Area",
    "countryStates": "Customer Country/Region",
    "create": "Create",
    "detail": "Detail",
    "endDate": "End Date",
    "exhibitionCalendar": "Market Calendar",
    "exhibitionDepartment": "Exhibition Department",
    "expectedFactoryDate": "Plan Factory Visit Date",
    "exportMes": "Export Product Information",
    "footerTips": "No more data",
    "generalManagerApproval": "General Manager's Approval",
    "hasBeenInvited": "Has Been Invited",
    "id": "ID",
    "mUnit": "(in millions)",
    "marketArrivialConfirm": "Market Arrivial Confirm",
    "marketRanking": "Market Ranking",
    "meetingContent": "Meeting Content",
    "mwSales": "ManWah Sales",
    "nationalitys": "VP/Sales Nationality",
    "nextClientVisitDate": "Next Client VisitDate",
    "officeExport": "Office Export",
    "online": "Online",
    "partyAttendanceNum": "Party Attendance",
    "pendingApproval": "Pending Approval",
    "pendingReview": "Pending Review",
    "pendingSubmission": "pending Submission",
    "percentage": "MW Percentage",
    "quantity": "QTY",
    "recall": "Recall",
    "reject": "Return to Previous Level",
    "reject1": "Return to Business Unit",
    "rejected": "Rejected",
    "remark": "Note",
    "retailer": "Retailer",
    "reviewComments": "Review Comments",
    "saleDeptInp": "Please Input Sales Department",
    "selectCountry": "Please select Country/Area",
    "selectCustomerName": "Please select Customer Name",
    "sofaSales": "Approximate Furniture Business Sales",
    "state": "State",
    "status": "Status",
    "submitForApproval": "Submit For Approval",
    "toBeInvited": "To Be Invited",
    "updateDate": "Uploaded Date",
    "view": "View",
    "viewExhibitionCalendar": "View Market Calendar",
    "vpSalesExport": "VP/Sales Export",
    "whetherAttendParty": "Attend MW Party",
    "wholesaler": "Wholesaler",
    "salesAnalysis": "Sales Analysis"
  },
  "Competing": {
    "formlable0": "Title",
    "formlable1": "Amount",
    "formlable2": "Details",
    "formlable3": "Describe",
    "formlable4": "User",
    "formlable5": "Date",
    "formlable6": "Country/Area",
    "tabTitle1": "Title",
    "tabTitle2": "Price",
    "tabTitle3": "Competitive Information"
  },
  "CompetitiveProductAnalysisDataListPage": {
    "addCompany": "Add Company",
    "addCustomer": "Add Customer",
    "cd": "Line Up & Competition",
    "competitorNum": "Uploaded QTY",
    "country": "Country/Area",
    "customerName": "Customer Name",
    "editCompany": "Edit Company",
    "editCustomer": "Edit Customer",
    "exportCompetingProducts": "Export Company Competitior",
    "handle": "Operation",
    "inset": "Add Competitor",
    "lastEditDate": "Last Edit Date",
    "recentUploadTime": "Last Uploaded Time",
    "sales": "Sales Rep",
    "save": "Add/Edit Competition",
    "uploadDate": "Uploaded Date",
    "uploader": "Uploader",
    "view": "View Competitor",
    "vp": "VP"
  },
  "CompetitiveProductAnalysisPage": {
    "categoryList": "Please Select Product Category",
    "collaborated": "Already Manwah Customer",
    "gradeList": "Please Select The Grade",
    "materialList": "Please Select The Cover",
    "nonCollaborated": "New Customer",
    "priceBandList": "Please Select A Price Range(Retail Price $)",
    "selectTips": "Please Select",
    "table": {
      "competitorCustomersNotUploaded": "Competitor Customers Not Uploaded",
      "competitorCustomersUploaded": "Competitor Customers Uploaded",
      "division": "Division",
      "handle": "Operation",
      "insert": "Add Information",
      "newRate": "Upload Progress",
      "title1": "Competitive Analysis",
      "title2": "Start Date",
      "title3": "End Date",
      "title4": "Total Accounts",
      "totalCustomerCount": "Total Customer Count",
      "uploadRate": "Upload Rate",
      "view": "View"
    },
    "to": "to",
    "tup": "Total Upload Progress ",
    "tur": "Total Upload Rate",
    "viewUploadedCompetitiveProductInformation": "View Uploaded Company Competitors Information"
  },
  "CompetitiveProductAnalysisStylePage": {
    "Currency": "Currency",
    "add": "Add",
    "addFrame": "Add Frame",
    "arrangementType": "Arrangement Type",
    "category": "Category",
    "classification": "Category",
    "clickUpload": "click to upload",
    "column": "Sku",
    "company": "Company",
    "cover": "Cover",
    "covers": "Covers List",
    "customer": "Customer",
    "delete": "Delete",
    "dimensionType": "Dimension",
    "displaySection": "Display",
    "dragUploadText": "Drop file here, or",
    "exhibitionPrice": "Market Price",
    "features": "Features",
    "filterPlaceholder": "Filter",
    "floorDisplayNumber": "Floor Display Number",
    "fobPrice": "FOB Price",
    "function": "Function",
    "image": "Main Image",
    "images": "Side Image",
    "leve": "Level",
    "model": "Model No.",
    "newFunctions": "New Functions",
    "no": "no",
    "notes": "Notes",
    "onlineOnly": "OnlineOnly",
    "pdc": "Product Type",
    "price": "Retail Price",
    "priceRange": "Price Range($)",
    "productName": "Product Name",
    "salesType": "Status",
    "search": "search",
    "size": "Size（L*W*H）",
    "tableSection": "Table",
    "type": "Type",
    "types": "Types",
    "update": "Uploaded",
    "uploadExceedLimit": "You can upload up to {limit} files",
    "uploadFailed": "Upload failed",
    "uploadImageFormatError": "Only mp4/avi  files can be uploaded",
    "uploadImageSizeError": "Upload file size cannot exceed {size}MB",
    "uploadTip": "Only jpg/png files can be uploaded, and no more than {size}MB",
    "vendor": "Supplier",
    "yes": "yes"
  },
  "ConfirmOperation": "Confirm Operation",
  "ContainerDimensions": {
    "allowed": "Allowed?",
    "dialogTitle": "{t} (units:in)",
    "flatPosition": "Flat Position",
    "flatWithHorizontalRotation": "Flat With Horizontal Rotation",
    "height": "Height",
    "length": "Length",
    "materialNo": "Material No.",
    "mixedStackingAllowed": "Mixed Stacking Allowed",
    "no": "No",
    "notAllowed": "Not Allowed",
    "onSidePosition": "On Side Position",
    "onSideWithHorizontalRotation": "On Side With Horizontal Rotation",
    "packageSize": "Package Size:{t}(in)",
    "permitted": "Permitted",
    "placementMethod": "Placement method",
    "stackingTiers": "Stacking Tiers",
    "tips": "Instructions: If there are no special restrictions, the following options can be left blank. If special restrictions exist, select \"No\" in the corresponding \"Is this placement method allowed?\" option. For placing other types of goods on top, select \"Not allowed\". For stacking layers, enter the maximum allowed number of layers using a numeric value.",
    "uprightPosition": "Upright Position",
    "uprightWithHorizontalRotation": "Upright With Horizontal Rotation",
    "width": "Width"
  },
  "CopyLinks": "Copy Links",
  "CountryNotselected": "Country Not selected or",
  "Customer": {
    "AddNewCustomerData": "Add New Customer Data",
    "ApproxFurnitureSales": "Approx Furniture Sales",
    "CustomerAnualSales": "Customer Anual Sales",
    "CustomerInformationion": "Customer Informationion",
    "CustomerManagement": "Customer Management",
    "LocalRanking": "Local Ranking",
    "ManWahSales": "ManWah Sales",
    "StoreNumber": "Store Qty",
    "TargetSales": "Target Sales",
    "ViaitingTimeLately": "Visiting date",
    "level": "Account class",
    "state": "State"
  },
  "CustomerPage": {
    "AccountReceivable": "Account Receivable",
    "AddBusinessCard": "Business Card",
    "AddCustomer": "Commitment Form",
    "AmountReceivable": "Account Receivable",
    "Attachment": "Attachment",
    "CNCSR": "CNCSR",
    "CREDITTRADEREFERENCES": "CREDIT TRADE REFERENCES",
    "CType": "Customer Type",
    "City": "City",
    "Cname": "Customer Name",
    "Cnumber": "Customer Code",
    "CompensationratioofRejection": "Compensation Ratio Of Rejection",
    "Confirm": "Confirm",
    "Country": "Country/Area",
    "Credit": "Credit",
    "CreditLine": "Credit Line",
    "CreditPeriodDays": "CreditPeriod (Days)",
    "CustomerDet": {
      "thTitle1": "Date",
      "thTitle10": "productCode",
      "thTitle11": "SKU Code",
      "thTitle12": "Model",
      "thTitle13": "Arrangement",
      "thTitle14": "Product Code",
      "thTitle14s": "Item Code",
      "thTitle15": "Terms Of Trade",
      "thTitle16": "Material",
      "thTitle17": "Color",
      "thTitle18": "Current Price",
      "thTitle19": "Sales amount of this year",
      "thTitle2": "Current Month's Sales",
      "thTitle20": "Sales amount of last year",
      "thTitle21": "Year-over-Year%",
      "thTitle22": "Picture",
      "thTitle23": "Current Total Shipment Amount",
      "thTitle24": "Shipment In Sales Amount Rate",
      "thTitle25": "Brand",
      "thTitle26": "Expiration Date",
      "thTitle27": "Sales Department",
      "thTitle28": "Last Period's Total Shipment Amount",
      "thTitle29": "YOY Comparison",
      "thTitle3": "Same Period Last Year",
      "thTitle30": "Current Total Shipment Quantity",
      "thTitle31": "Last Period's Total Shipment Quantity",
      "thTitle32": "Shipment In Sales Quantity Rate",
      "thTitle33": "Invoice Amount",
      "thTitle34": "Invoice Qty",
      "thTitle35": "First shipment date",
      "thTitle36": "Customer Transaction Price",
      "thTitle37": "FOB Price （Including Tariff)",
      "thTitle38": "FOB Price",
      "thTitle39": "Customer Transaction Price（Including Tariff)",
      "thTitle4": "Monthly YOY Rate",
      "thTitle40": "Total Amount of {t} Budget",
      "thTitle5": "Expense Type",
      "thTitle6": "Current Amount",
      "thTitle7": "Sales Amount",
      "thTitle8": "Model",
      "thTitle9": "skuCode",
      "tnouo": "Open Order"
    },
    "EffectiveDate": "Effective Date",
    "ExpiryDate": "Expiry Date",
    "Fabric": "Material",
    "InCompany": "Insurance Company",
    "InsuranceCompany": "Insurance Company",
    "LineUp": {
      "addFloorSlot": "Add Floor Slot",
      "amount": "Amount",
      "blankets": "Leather / Fabric",
      "budget": "{t} Year Budget",
      "coverCode": "Cover Code",
      "coverName": "Cover Name",
      "floorDisplays": "Floor Displays",
      "fobPrice": "FOB Price (USD)",
      "growthRate": "Growth Rate",
      "introductionDate": "First Shippment Date",
      "level": "Level",
      "model": "Model",
      "openOrders": "Open orders (All status)",
      "picture": "Picture",
      "previousYearJanDec": "{t} Annual Sales Volume",
      "salesYTD": "{t} SalesYTD",
      "samePeriodSalesPreviousYear": "{t} Sales Volume in the Same Period",
      "sku": "SKU",
      "spec": "Category",
      "status": "Status",
      "year": "Year"
    },
    "MWVP": "Man Wah VP/Sales Representative/VP Assistant/CSR Information",
    "MainImage": "Main Image",
    "OverdueAmount": "Overdue Amount",
    "PoCode": "Postal Code",
    "RegionalVP": "RegionalVP",
    "Remark": "Remark(Specs.)",
    "STP": "Ship-To-Party",
    "SalesRepresentive": "Sales Representative",
    "SkuClass": "Style type",
    "Sponge": "Filler",
    "TOT": "Terms Of Trade",
    "VNCSR": "VNCSR",
    "VPAssistant": "VPAssistant",
    "Variation": "Variation",
    "addr": "Address",
    "comments": "SPECIAL INSTRUCTIONS / COMMENTS",
    "mainPhoto": "",
    "modelTye": "New Model to Customer",
    "no": "No",
    "paymentTerm": "PAYMENT TERM",
    "price": " Selling price",
    "priceSecond": "Fob Factory Price",
    "prices": "Fob Approved Selling Price",
    "quty": "Estimated Containers",
    "rate": "YOY%",
    "saleDept": "Sales Department",
    "sato": "Order Statistics Analysis Report",
    "tabTitle1": " Sales Amount",
    "tabTitle2": "Model Ranking",
    "tabTitle3": "Surcharge",
    "tabTitle4": "Line Up",
    "tabTitle5": "Chargeback",
    "tabTitle6": "Customer Info",
    "tb1": "Name",
    "tel": "Phone",
    "tips": "The current style already has the main image. Do you confirm the replacement?",
    "tipsInfo": "The uploaded image is not in standard 16:9 aspect ratio, which will affect the export display. Please try to upload standard ratio images.",
    "wip": "WIP",
    "yes": "Yes"
  },
  "Date": "Date",
  "DepPleaseSelectBrand": " Brand",
  "DepPleaseSelectFactory": "Factory",
  "Documents": {
    "filetitle": "Document title",
    "uptime": "Upload date",
    "usDp": "US Department Documents"
  },
  "Download": "Download",
  "Downloads": "Downloads",
  "EditCover": "Edit Cover",
  "EditVideo": "Edit Images&Video",
  "EndDate": "End Date",
  "ExReservationInvitationSummary": {
    "achievementRate": "Achievement Rate",
    "division": "Division",
    "invitationAchievementRate": "Invitation Achievement Rate",
    "numberOfClients": "Number Of Customer",
    "numberOfClientsDecliningAttendance": "Declining Attendance Customer ",
    "numberOfClientsInvited": "Invited Customer",
    "numberOfCollaboratedClients": "Already Manwah Customer",
    "numberOfNonCollaboratedClients": "New Customer",
    "plannedInvitationRate": "Planned Invitation Rate",
    "plannedInvitationRateForCurrentExhibition": "Planned Invitation Rate Of Current Market",
    "plannedNumberOfClientsToInvite": "Planned Number Of Customer To Invite",
    "title": "Market Invitations Summary Table",
    "totalInvitationsCompleted": "Total Completion Invitations",
    "totalNumberOfClients": "Total Customer",
    "totalPlannedInvitations": "Total Planned Invitations",
    "LYIC": "Last Year Invited Customer",
    "YR": "YOY Rate"
  },
  "FileIsNull": "file is null",
  "Firstlevelreport": "First level report",
  "Hello": "Sell More",
  "HiRes": "HiRes",
  "Home": {
    "Department": "Department",
    "Isitoverdue": "Is it overdue",
    "OverdueAmount": "Overdue Amount",
    "SaleAmount": "Sales Amount",
    "charTitle1": "Monthly Sales YoY",
    "charTitle2": "Order Intake and Shipped Report",
    "charTitle3": "Customer Sales Ranking",
    "charTitle4": "Top Customers by Overdue Amount",
    "charTitle5": "My Best Selling Models",
    "charTitle6": "Department’s Best Selling Models",
    "charTitle7": "My Best Selling Covers",
    "charTitle8": "Department’s Best Selling Covers",
    "color": "Color",
    "lastYear": "Last Year",
    "money": "Money",
    "more": "more",
    "radio": "Radio",
    "tbTitle1": "Customer Name",
    "tbTitle2": "Current Month's Sales",
    "tbTitle3": "Same Month Last Year's Sales",
    "tbTitle4": "Account Receivable",
    "tbTitle5": "Growth Ratio%",
    "thisYear": "This Year"
  },
  "ImagesAndVideo": {
    "Body": "Body",
    "Clear": "Clear",
    "EmailTo": "Email To",
    "SendEmail": "Send Email",
    "Subject": "Subject",
    "remove": "remove",
    "type": "Type"
  },
  "InventoryPlatform": {
    "ADOL": "Delay Days (Promise-ETD/ETA)",
    "ALT": "Lead Time (PO Date/PI Approved-ETD)",
    "APAD": "PI Approved Days (PO Date-PI Approved)",
    "APD": "Production Days (PI Approved-Actual Finish)",
    "ASD": "Shipment Days (Actual Finish -ETD)",
    "ActualReadyDate": "Actual Ready Date",
    "CCD": "Competitor Created Date ",
    "Container": "Container#",
    "CustomerInventory": "Actual Stock QTY",
    "CustomerInventoryInfoTpl": "Customer Inventory Information Template",
    "DeliverNo": "Delivery Order Number",
    "ETA": "ETA",
    "ETD": "ETD",
    "EstReadyDate": "Est. Ready Date",
    "FCD": "Factory Confirm(First)",
    "FCN": "Factory Confirm(Final)",
    "IHOQ": "In Hand Order Qty",
    "ImportSuccessful": "Upload Successful",
    "InProduction": "In Production",
    "IncorrectDownload": "Incorrect Download",
    "LoadingDate": "Loading Date",
    "MeterialAvailableStock": "Material Available Stock",
    "MeterialInTransit": "Material In Transit",
    "OAR": "Order Adjust Reason",
    "OrderQuantity": "Order Quantity",
    "PAD": "PI Approved Date",
    "PAFC": "Factory Confirm Days (Pl Approved-Factory Confirm)",
    "PCD": "Procurement Confirm Days (PI Approved-Procurement Confirm)",
    "MOD": "Material Arrival  On-Time Days（Request Date-Arrival Date-15 day)",
    "POTD": "On-Time Production Days(Request Date – Completion Date)",
    "PCFT": "Procurement Confirm",
    "UPD": "Procurement Confirm(Final)",
    "PD": "PO Date",
    "PO": "PO#",
    "ProductInStock": "Product Stock QTY",
    "ProductInTransit": "In Transit",
    "ProductInfo": "Product Info",
    "ProductInfoTpl": "Product Information Template",
    "ReadyDate": "Ready Date",
    "ReplenishmentQTY": "Backup Order QTY",
    "RequestReadyDate": "Request Ready Date",
    "SRD": "SO Receiving Date",
    "SRL": "SO Receiving-Loading",
    "ShippedQuantity": "Shipped Quantity",
    "StockQTY": "Available Stock QTY",
    "StockQTYs": "Stock QTY ",
    "TAPOS": "Average Lead Time",
    "ThisWeekInvoice": "Sold QTY",
    "UnProduced": "Un-produced",
    "WeekEndTime": "Week End Time",
    "WeekStartTime": "Week Start Time",
    "adtips": "Delay Days",
    "basicInfo": "Basic Info",
    "cancel": "Cancel",
    "categoryId": "Category",
    "changeDays": "Order Adjust Days",
    "color": "Color",
    "confirm": "Confirm",
    "containerNumber": "Container Number",
    "createTime": "Create Time",
    "createUser": "Create User",
    "customer": "Customer",
    "customerCode": "Customer Code",
    "customerDataTpl": "Customer Data Template",
    "customerName": "Customer Name",
    "customerPo": "Customer Po",
    "customerSKU": "Customer SKU#",
    "deleteConfirm": "Do you want to delete the selected record?",
    "deleteSuccessful": "Delete successful",
    "disable": "Inactive",
    "enable": "Active",
    "endMonth": "End Month",
    "eta": "ETA",
    "etd": "ETD",
    "fabricNumber": "Cover Code",
    "features": "Features",
    "file": "File",
    "item": "Spec.",
    "model": "Model",
    "mwSKU": "MW SKU#",
    "numberOfStore": "Store QTY",
    "operate": "Operate",
    "pleaseSelectData": "Please select data",
    "po": "PO",
    "prompt": "Prompt",
    "remark": "Remark",
    "save": "Save",
    "saveSuccess": "Save Successful",
    "seq": "Seq",
    "shipTo": "Ship To",
    "sku": "Sku",
    "startMonth": "Start Month",
    "status": "Status",
    "storeFloorSampleQTY": "Store Floor Sample QTY",
    "supplier": "Supplier",
    "undeliveriedQTY": "Undeliveried QTY",
    "uploadTip1": "The file size cannot exceed 5M",
    "uploadTip2": "The number of document lines cannot exceed 100 million",
    "weekDate": "Week Date"
  },
  "Large": "Large",
  "LifeStyle": "Lifestyle Photo",
  "MainPushStyleSalesRanking": {
    "category": "Category",
    "categoryRanking": "Category Ranking",
    "color": "Color",
    "cumulativeNetSales": "Cumulative net sales for the past six months",
    "customer": "Customer",
    "department": "Division",
    "fandm": "SKU/Code",
    "ferth": "Ferth",
    "fobPrice": "Fob Price",
    "level": "Level",
    "levelRanking": "Level Ranking",
    "mark": "Mark",
    "model": "Model",
    "netSales": "Net sales for {t}",
    "numbersOfDisplay": "Numbers Of Display",
    "orderQuantityInIheNext3months": "Order quantity in the next 3 months  ({t})",
    "picture": "Picture",
    "recommendedStatus": "Recommended Status",
    "running": "Running",
    "type": "Cover"
  },
  "Medium": "Medium",
  "ModelsDet": {
    "title": "Pricing And Images"
  },
  "MonthRange": "ETD Date",
  "Normal": "Normal",
  "OrderAverageDeliveryTime": {
    "cargoState": "Cargo State",
    "customerName": "Customer Name",
    "exportFileName": "Customer Order Average Delivery Time",
    "no": "No.",
    "orderA2C": "PI Issued → Signed",
    "orderC2D": "PI Signed → Confirmed",
    "orderCompleted2Delivery": "Finished → Shipped",
    "orderCompleted2Vanning": "Finished → Loaded",
    "orderCreateTime": "Order Create Time",
    "orderD2Completed": "PI Confirmed → Finished",
    "orderOccupationTime": "Order Occupancy Time",
    "orderQuantity": "Order Quantity",
    "shipped": "Shipped",
    "total": "Lead Time  PI Issued → PI Shipped",
    "unshipped": "Unshipped",
    "vpSales": "VP/Sales"
  },
  "OrderDeliveryTimeOverviewOrDetail": {
    "create": "",
    "currentStatus": "Current Status",
    "custom": "Custom",
    "acStatus": "A&C",
    "cycleConditions": "Cycle Conditions",
    "day": "Day",
    "deliveryOrNot": "Whether To Ship",
    "figure1": "Average Delivery Time",
    "figure2": "Delivery Period Segmentation",
    "firstDeliveryDate": "First Delivery Date",
    "hasBeenShipped": "Has Been Shipped",
    "haveBeenCompleted": "Have Been Completed",
    "haveSigned": "Have Signed",
    "inTheProduction": "In The Production",
    "installedCabinet": "Installed Cabinet",
    "invalidDateRange": "Invalid Date Range",
    "month": "Month",
    "orderA2C": "PI Issued → Signed",
    "orderA2Delivery": "PI Issued → Shipped",
    "orderC2D": "PI Signed → Confirmed",
    "orderCompleted2Delivery": "Finished → Shipped",
    "orderCompleted2Vanning": "Finished → Loaded",
    "orderCreareDate": "PI Create Date",
    "orderCreateTime": "Order Create Time",
    "orderD2Completed": "PI Confirmed → Finished",
    "orderD2Delivery": "PI Confirmed → Shipped",
    "orderD2ExpectedCompleted": "PI Confirmed → Expected Finished",
    "orderId": "PI NO",
    "orderOccupationTime": "Order Occupancy Time",
    "reviewDateD": "Review PI Confirmed Date",
    "siteValidation": "Site Validation",
    "title1": "Trend Of Average Delivery Time Shipped (Unit: Days)",
    "title2": "Delivery Period Distribution (Unit: Odd Number)",
    "total": "Total",
    "totalDeliveryTime": "Total Delivery Time"
  },
  "OrderInput": "Order Input Summary",
  "OrderInputDetailList": "Order Input Detail List",
  "OrderIntake": {
    "TooC": "Total 0per Order Cnty",
    "styleStatisticalDetail": "StyleStatisticalDetail",
    "styleCode": "StyleCode",
    "bookDate": "Book Date",
    "color": "Color",
    "currentMonthDeliveries": "Current Month Deliveries",
    "customerName": "Customer",
    "customerOrderNumber": "Customer Order Number",
    "lastMonthShipments": "Last Month Shipments",
    "monthDate": "Estimated Ready Date",
    "mp": "MaterialParameters",
    "numberOfDisplaySetups": "Number Of Display Setups",
    "occupancyDate": "Occupancy Date",
    "styleOrderInfo": "Style Order Info",
    "styleInfo": "Style Info",
    "orderInfo": "Order Info",
    "orderNum": "Order Num",
    "ordersReceivedLastMonth": "Orders Received Last Month",
    "quantity": "Quantity",
    "salesOrder": "Sales Order",
    "spec": "Spec.",
    "status": "Status",
    "style": "Model",
    "subtotal": "Sub Total",
    "total": "Total",
    "unitPrice": "Unit Price",
    "vpSales": "VP/Sales",
    "noSo": "Stock without SO",
    "noSoInfo": "Stock without SO Info"
  },
  "OrderPage": {
    "Destination": "Destination",
    "Order": "Order",
    "OrderDate": "Order Date",
    "PONO": "PO NO",
    "PaymentTerms": "Payment Terms",
    "Period": "Initial Planned Finish Date",
    "indexTb": {
      "t1": "Customer Code",
      "t2": "Customer Name",
      "t3": "PI Issued",
      "t4": "PI Signed",
      "t5": "Factory confirmed",
      "t6": "Scheduled",
      "t7": "Inventory",
      "t8": "Shipped",
      "t9": "All"
    },
    "orderlist": {
      "th1": "Request Delivery Date",
      "th10": "ETD",
      "th11": "Actual Completion Date",
      "th12": "Container No.",
      "th13": "POD Status",
      "th14": "ETA",
      "th15": "Invoice Number",
      "th16": "Invoice Amount",
      "th17": "Actual Completion Date",
      "th2": "Order Receive Date",
      "th3": "Planned Production Date",
      "th4": "Model",
      "th5": "Color",
      "th6": "Brand",
      "th7": "Expected Material ready date",
      "th8": "Actual Material ready date ",
      "th9": "Estimated Completion Date"
    },
    "payTerms": "Payment Terms",
    "tabTitle1": "All",
    "tabTitle2": "PI Issued",
    "tabTitle3": "PI Signed",
    "tabTitle4": "Factory confirmed",
    "tabTitle5": "Scheduled",
    "tabTitle6": "Inventory",
    "tabTitle7": "Shipped",
    "thead": {
      "title1": "Model",
      "title2": "Desc.",
      "title3": "Color",
      "title4": "Quantity",
      "title5": "Price"
    }
  },
  "Performance": {
    "Acutal1": "Acutal 2023",
    "Acutal2": "Acutal 2019",
    "BIT": "Budget Import Template",
    "Budget": "Budget 2024 Jan-Dec",
    "Division1": " Total",
    "Division2": " Division Two",
    "Division3": " Division Three",
    "ESAPC": "Export Sales Analysis Per Customer",
    "cabinet": "Ctn Qty",
    "tabTitle0": "Customer Name",
    "tabTitle1": " Budget",
    "tabTitle10": " Growth Ratio",
    "tabTitle11": " Actual ",
    "tabTitle2": " Acutal",
    "tabTitle3": " Acutal",
    "tabTitle4": " Actual/Budget Ratio ",
    "tabTitle5": " Growth Ratio",
    "tabTitle6": " Budget ",
    "tabTitle7": " Acutal ",
    "tabTitle8": " Acutal ",
    "tabTitle9": " Actual/Budget Ration ",
    "vpassistant": "VP Assistant"
  },
  "PleaseConfirmPassword": "Please enter it again",
  "PleaseEnter": "Please Enter",
  "PleaseEnterNewPassword": "Please enter a new password",
  "PleaseInput": "Please Input",
  "PleaseInputBudge": "Please Input Budge",
  "PleaseInputColor": "Please Input Color",
  "PleaseInputCubes": "Please Input cubes",
  "PleaseInputDepth": "Please Input depth",
  "PleaseInputDescription": "Please Input description",
  "PleaseInputLength": "Please Input length",
  "PleaseInputPrice": "Please Input price",
  "PleaseInputSku": "Please Input sku",
  "PleaseInputTitle": "Please Input Title",
  "PleaseInputcovers": "Please Input covers",
  "PleaseSelect": "Please select",
  "PleaseSelectArrangements": "Please select arrangements",
  "PleaseSelectModel": "Please select model",
  "PleaseSelectTheDownloadMethod": "Please select the download method!?",
  "PleaseSelectType": "Please select type",
  "Receivables": "Overdue Account Receivables",
  "Report": {
    "AllTypes": "All Types",
    "PleaseEnterCodeOrName": "Please enter code or name",
    "PleaseEnterNameSearch": "Please Enter Name Search"
  },
  "Secondaryreport": "Secondary report",
  "SelectFile": "Select file",
  "SendContentViaEmail": "Send Content Via Email",
  "ShippedDetailList": "Shipped Detail List",
  "ShippedOrderSummary": "Shipped Order Summary",
  "Small": "Small",
  "StartDate": "Start Date",
  "Temporarily": "No Data Available",
  "Tips": "Tips",
  "ToDoReminder": {
    "competingProductsRelated": "Company Competitior Related",
    "marketsRelated": "Markets Related",
    "orderRelated": "Order Related",
    "otherRelated": "Other Related"
  },
  "ToSendToMultipleEmails": "To send to multiple emails,please add a com between addresses",
  "TravelList": {
    "byway": "Others"
  },
  "UploadPicturesCaninJPGformat": "Upload pictures can only be in JPG format!",
  "Videos": "Videos",
  "VisitTime": "Visit Time",
  "addCompetitors": {
    "PleaseInputAmount": "Please Input Amount",
    "PleaseInputCustomerDescribe": "Please Input Customer Describe",
    "PleaseInputDetails": "Please Input Details",
    "PleaseInputTitle": "Please Input Title",
    "PleaseInputUserName": "Please Input User Name",
    "selectdate": "select date"
  },
  "addSuccess": "add success",
  "addTravel": {
    "CustomerDetailsP": "Please Input Customer DetailsP",
    "CustomerLocation": "Please Input Customer Location",
    "CustomerName": "Please Input Customer Name",
    "Opportunity": "Please Input Opportunity",
    "PleaseInputContacts": "Please Input Contacts"
  },
  "competingGoodsInfo": {
    "Commitments": "Commitments",
    "title1": "SKU",
    "title2": "Description",
    "title3": "Cubes",
    "title4": "Length",
    "title5": "Depth",
    "title6": "Price",
    "title7": "Total Price"
  },
  "confirm": "Confirm",
  "confirmError": "Passwords do not match",
  "confirmPassword": "confirm password",
  "covers": {
    "coverGroup": "Cover Group",
    "coverName": "Cover Name",
    "coverNumber": "Cover Code",
    "coverType": "Cover Type"
  },
  "dash": {
    "Year": "Year"
  },
  "editPricelist": "Edit Price List",
  "factory": "Factory",
  "firstLogin": "First login or password is too simple",
  "formlabel": {
    "Count": "Count",
    "Department": "Department",
    "Month": "Month",
    "Quarter": "Quarter",
    "ResetBtn": "Reset",
    "ReturnBtn": "Return",
    "SearchBtn": "Search",
    "Selectfile": "Select file",
    "SingleBtn1": "Order Intake",
    "SingleBtn2": "Order Shipped",
    "SingleCount": "Total Order Intake",
    "SingleCounts": "Total Shipped",
    "Year": "Year",
    "addBtn": "Add",
    "allExport": "All Export",
    "cancel": "Cancel",
    "classify": "Classify",
    "createCommitment": "Create Commitment",
    "createdDate": "Created Date",
    "delete": "Delete",
    "download": "Download and upload the template",
    "downloadTemplate": "Download Template",
    "downloadbtn": "Download",
    "editBtn": "Edit",
    "export": "Export",
    "exportCountSheet": "Export order summary",
    "exportData": "ExportData",
    "lineup": "Export Line Up",
    "exportDataAll": "Export Commitment Orders Catagory Details",
    "exportDataAllT": "Export Order Status Details",
    "exportDataSecond": "Export Committment Orders",
    "exportDataThree": "Export Order Status",
    "exportDatas": "Export Commitments List",
    "exportNewData": "Export Commitment Order Summary Report",
    "exportExcel": "ExportExcel",
    "exportExcel1": "Only Main Image",
    "exportExcel2": "Including All Images",
    "exportPdf": "ExportPdf",
    "exportType": "Market Invited Customer Detailed List",
    "handle": "Edit",
    "import": "Import",
    "keyword": "Keyword",
    "label1": "Customer invitation information report",
    "label2": "Customer invitation information update template",
    "label3": "Split Sheet",
    "label4": "Merge Export",
    "label5": "Delivery Schedule Details",
    "label6": "PI Approval Detail Report",
    "label7": "Inventory Overdue Days Report",
    "label8": "Export Division Finished Goods Inventory Age Analysis",
    "partExport": "Part Export",
    "submitBtn": "Submit",
    "title": "Title",
    "updateDate": "Uploaded Date",
    "upload": "Upload",
    "exportAnsis": "Export Committment Orders Analysis Report"
  },
  "level": "Level",
  "loading": "loading",
  "logout": "Logout",
  "logoutConfirm": "Logout of the current account? The opened tabs and user settings will be saved.",
  "menu": {
    "menu_title15": "Markets List",
    "menu_title16": "Commitments List",
    "menu_title17": "Summary by Customer",
    "menu_title18": "Summary by Model"
  },
  "menus": {
    "Account": "Account",
    "AccountHierarchySettings": "Account Hierarchy Settings",
    "Admin": "Admin",
    "Arms": "Arms",
    "Arrangements": "Arrangements",
    "Backs": "Backs",
    "Catalog": "Documents",
    "Categories": "Categories",
    "Commitments": "Markets List",
    "CompetitiveProductAnalysis": "Customer Competitors",
    "CompetitiveProductAnalysisDataList": "Competing Products Customer Detailed List",
    "Competitorslist": "Competitor Related",
    "ConfirmOrderDetails": "Market Confirmed Order Details",
    "ContainerDimensions": "Container Dimensions",
    "ContentRelated": "Content Related",
    "Cover": "Covers",
    "CoverFeature": "Cover Feature",
    "Covers": "Covers",
    "CoversGrades": "Cover Grades",
    "CoversGroups": "Cover Groups",
    "CoversRelated": "Covers Related",
    "Customer": "Customer",
    "CustomerManagement": "Customer Management",
    "CustomerSalesInfo": "Customer Information Management",
    "DFSEDIInvolce": "DFS EDI Invoice",
    "Documents": "Documents",
    "ExReservation": "Market Reservation",
    "ExReservationInvitationSummary": "Market Reservation",
    "ExReservationInvitationSummaryForBusiness": "Market Invited Customer Summary Table",
    "ExReservationTabs": "Market Invited Customer Detailed List",
    "ExhibitionBonusDistribution": "Exhibition Bonus Distribution",
    "ExhibitionBonusStyles": "Exhibition Bonus Styles",
    "ExportDeliveryReport": "Production and Shipping Performance Analysis",
    "Features": "Features",
    "FinanceReports": "Financial Report",
    "FollowUpSituationTable": "Market Order Statement",
    "Frames": "Frames",
    "InventoryPlatform": "Inventory Platform",
    "InventoryPlatformCustomerData": "Customer Data",
    "InventoryPlatformCustomerDataNew": "Customer Data",
    "InventoryPlatformProductInfoConfig": "Product Information",
    "InventoryPlatformSharingReport": "Inventory Sharing Report",
    "InventoryReport": "Inventory Report",
    "LeaderboardReport": "Ranking",
    "MainPushStyleSalesRanking": "Model Sales Ranking",
    "MainPushStyleSalesRankingTwo": "Model Sales Ranking",
    "MarketNewModelBonusReport": "Market New Model Bonus Report",
    "Mechanisms": "Mechanisms",
    "Models": "Models List",
    "NewModelRelated": "New Model Related",
    "NewStyleMaintenance": "New Model Maintain",
    "Order": "Order Status",
    "OrderAverageDeliveryTime": "Customer Order Average Delivery",
    "OrderDeliveryTimeDetail": "Delivery Time Detail",
    "OrderDeliveryTimeOverview": "Delivery Time Overview",
    "OrderIntake": "Open order intake",
    "OrderStatus": "Order Status",
    "Performance": "Sales Review",
    "Photos": "Photos",
    "Price": "Price",
    "PriceParent": "Prices",
    "ProductRecommendation": "Competitive Information",
    "Report": "Report",
    "ReportEight": "Export Sales Analysis Per Model",
    "ReportEleven": "Statement Of Business Shipments And Revenues",
    "ReportFive": "Inventory Age Report",
    "ReportFour": "Customer Container Tracking Report（Surcharge）",
    "ReportNine": "Sales Detail Report",
    "ReportOne": "Net Sales Revenue Analysis",
    "ReportSeven": "Export Sales Analysis Per Cover No",
    "ReportSix": "Export Sales Analysis Per Customer",
    "ReportTen": "Service Order Status Report",
    "ReportThree": "Order Intake and Shipped Report",
    "ReportTwenty": "Customer Line Up & Competition Summary",
    "ReportTwentyV2": "Customer Product Display & Competing Product Status",
    "ReportTwo": "Overdue Account Receivables",
    "RevenueReport": "Sales Revenue Shipping Report",
    "SKU": "SKU",
    "SalesReports": "Sales Report",
    "Seats": "Seats",
    "SpecificationRelationship": "Specification Relationship",
    "Styles": "Styles",
    "ToDoReminder": "To-do Items",
    "TotalCommitments": "Summary by Model",
    "Travel": "Travel",
    "TravelTabs": "Travel",
    "Video": "Video",
    "Videos": "Videos",
    "achievement": "Performance",
    "cart": "Check List",
    "competingGoods": "Price Lists",
    "competitors": "Company Competitior",
    "createdAccount": "Account Management",
    "exhibition": "Markets",
    "index": "Dashboard",
    "lmageVideo": "Images&Video",
    "loginlog": "Login Logs",
    "modelsManager": "Models",
    "mwhCompetitorFeatures": "Competitors Features",
    "newCP": "Company Competitors",
    "newCompetions": "Competitors",
    "newPrices": "Prices",
    "others": "Others",
    "poList": "PI List",
    "qsInventory": "QS Model",
    "qsReport": "QS Report",
    "quotationSheet": "Price Lists",
    "rai": "Resignation Succession",
    "relatingPrices": "Prices",
    "resetPassword": "Reset Password",
    "tableList": "Summary by Customer",
    "tableListbyCustomer": "Commitments List",
    "usCP": "Southern Motion",
    "vpsalesMezzanine": "Competitors Customer Summary Table"
  },
  "menusObj": {
    "menu_title1": "Dashboard",
    "menu_title10": "Documents",
    "menu_title11": "Performance",
    "menu_title12": "Images And Video",
    "menu_title13": "Models",
    "menu_title14": "Prices",
    "menu_title15": "Customer Pricelists",
    "menu_title16": "Markets",
    "menu_title17": "PortalCommitments",
    "menu_title2": "Customer",
    "menu_title3": "Order Status",
    "menu_title4": "Report",
    "menu_title5": "Travel",
    "menu_title6": "Company Competitior",
    "menu_title7": "Pricelist",
    "menu_title8": "Commitments",
    "menu_title9": "Video"
  },
  "model": "Model",
  "modelStatus": {
    "dropped": "Dropped",
    "newCover": "New Cover",
    "newModel": "New Model",
    "phasedOut": "Phase Out",
    "running": "Running"
  },
  "modifyPassword": "modify password",
  "newPassword": "new password",
  "newPriceList": {
    "Comments": "Comments",
    "Created": "Created",
    "Link": "Link",
    "Rep": "Rep",
    "Updated": "Updated",
    "columns1": "Vietnam Canada",
    "columns2": "CFR",
    "columns3": "FOB",
    "columns4": "Photo",
    "createdPricelist": "Created Pricelist",
    "entries": "entries",
    "pricelistForm": "Pricelist Form",
    "title1": "Terms",
    "typeToFilter": "Type To Filter"
  },
  "no": "No.",
  "noMore": "NoMore",
  "oldPassword": "Old password",
  "order": {
    "Division": "Division",
    "Market": "Market",
    "PleaseEnterTheSearchKeyword": "Please enter the search keyword"
  },
  "others": {
    "DFSEDIInvolce": {
      "EDIFileName": "EDI File Name",
      "ExportEDIFile": "Export EDI File",
      "ExportPOFile": "Export POFile",
      "lnvoiceCode": "invoice Code"
    }
  },
  "pageTitle": {
    "CompetitiveProductAnalysis": "Competitive Analysis",
    "Customer": " Customer",
    "CustomerDet": "Customers Profile",
    "Order": "Order",
    "OrderStatus": "Order Status",
    "TravelList": "Travel List"
  },
  "passwordNoChange": "New password cannot be the same as the old password",
  "passwordRequirements": "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one digit",
  "price": {
    "Current": "Brand",
    "From": {
      "Arms": "Arms",
      "Close": "Close",
      "Construction": "Construction",
      "CountryOfOrigin": "Country of origin",
      "CreateModel": "Create Model",
      "ModelForm": "Model Form",
      "Name": "Name",
      "Remarks": "Remarks",
      "Style": "Style features",
      "Unique": "Unique"
    },
    "NewModel": "New Model",
    "TypeToFilter": "Type to filter",
    "addtoTheOriginalCombination": "Add to the Original Combination",
    "combinationName": "combinationName",
    "createNewCombination": "Create a New Combination",
    "modifyFunctionName": "Modify Function Name",
    "modifyTheCombinationName": "Modify the combination name",
    "table": {
      "Arms": "Arms",
      "Backs": "Backs",
      "Brand": "Brand",
      "Categories": "Categories",
      "Collections": "Collections",
      "Current": "Current",
      "Features": "Features",
      "Image": "Image",
      "Mechanisms": "Mechanisms",
      "Model": "Model",
      "Remarks": "Remarks",
      "Seats": "Seats",
      "Styles": "Styles",
      "handle": "Handle",
      "noPic": "No Image Available"
    }
  },
  "prices": {
    "CoverGrade": "Cover Grade",
    "CoverType": "Cover Type",
    "Cube": "Cubs(m³)",
    "Cubes": "Cubs(cuft)",
    "Depth": "Depth(in)",
    "Depths": "Depth(cm)",
    "Edit": "Edit",
    "Function": "Function",
    "MaterialClass": "Cover Type",
    "MaterialInfo": "Cover Grade",
    "MotionType": "Motion Type",
    "PieceCount": "Piece Count",
    "PowerClass": "Motion Type",
    "Type": "Type",
    "addNewPriceSheet": "Add New Price List",
    "addPriceSheet": "Add Price List",
    "addToPriceSheet": "Add To Price List",
    "allPrice": "All Prices",
    "back": "View Arrangements",
    "category": "Category",
    "change": "Edit",
    "chooseCover": "Available Covers",
    "clickPreview": "Click on the Cover Grades to show all the prices",
    "cnP": "China/FOB",
    "description": "Description",
    "errorTip": "The combination name and function are required",
    "errorTips": "The selected prices are duplicated and cannot be added",
    "exportPriceSheet": "Generate Quote Sheet",
    "factory": "choose factory",
    "height": "Height(in)",
    "heights": "Height(cm)",
    "length": "Length(in)",
    "lengths": "Length(cm)",
    "multipleSelection": "MultipleSelection",
    "newPriceList": "New Price List",
    "noPic": "No Images Available",
    "priceEnd": "priceEnd",
    "priceLists": "Price Lists",
    "priceSheetColorNum": "Select Color Number For Quote Sheet",
    "priceSheetFileName": "File Name For Quote Sheet",
    "priceSheetName": "Price List Name",
    "priceStart": "priceStart",
    "priceTickets": "Catalog",
    "priceValidity": "Price Validity",
    "pricesImportTemplate": "Prices Import Template",
    "quoteLabel": "Quote",
    "quoteRequired": "Quote Required",
    "quoteSheet": "Quote Sheet",
    "radio1": "Product information",
    "radio2": "Manually Add ",
    "radio3": "SAP",
    "rawPic": "Images",
    "sceneGraph": "Lifestyle",
    "search": "Search",
    "selectPic": "Select a Photo For Quote Sheet",
    "specificationNum": "SpecificationNum",
    "style": "Search by Model",
    "titleInfo": "SourceType",
    "vietnamP": "Vietnam/FOB",
    "view": "View",
    "viewPriceSheet": "View Price List",
    "viewOrderList": "View Commitments",
    "viewInfo": "Commitment"
  },
  "productRecommendation": {
    "Division": "Division",
    "businessId": "Business No.",
    "businessName": "Sales Rep Name",
    "category": "Category",
    "color": "Color",
    "customer": "Customer",
    "exportProductRecommendationScheme": "{t} Proposal plan",
    "exportProductRecommendationTable": "{t} Proposal list",
    "exportProductRecommendationTemplate": "{t} Template",
    "fabric": "Fabric",
    "followRecords": "Follow Records",
    "functionFeatures": "Function Features",
    "importProductRecommendationTableInformation": "{t} Proposal Info",
    "level": "Level",
    "material": "Cover",
    "model": "Model",
    "price": "Price （$）",
    "recommendedPriority": "Recommended Priority",
    "recommendedReason": "Recommended Reason",
    "required": "Required",
    "size": "Size",
    "specification": "SKU",
    "style": "Style",
    "vpSales": "VP/Sales"
  },
  "psdiv": "Please Select Division",
  "report20": {
    "CRL": "Customer Ranking List",
    "FOBPrice": "Price",
    "Fabric": "Fabric",
    "LandedPrice": "Landed Price",
    "RetailPrice": "Retail Price",
    "classification": "Level",
    "floorSlot": "Floor Slot",
    "fobPrice": "Fob Price",
    "leather": "Leather",
    "mwSlot": "MW Slot",
    "picture": "Picture",
    "rank": "No.",
    "storeNumber": "Store QTY",
    "suppliers": "Supplier",
    "total": "Total"
  },
  "reportItem": {
    "ItemTitle1": "Net Sales Revenue Analysis",
    "ItemTitle10": "Service Order Status Report",
    "ItemTitle11": "Statement Of Business Shipments And Revenues",
    "ItemTitle2": "Overdue Account Receivables",
    "ItemTitle3": "Order Input And Shipping Report",
    "ItemTitle4": "Customer Container Tracking Report（Surcharge）",
    "ItemTitle5": "Ready CTNS To Ship",
    "ItemTitle6": "Export Sales Analysis Per Customer",
    "ItemTitle7": "Export Sales Analysis Per Cover No",
    "ItemTitle8": "Export Sales Analysis Per Model",
    "ItemTitle9": "Sales Detail Report",
    "Title": "Report"
  },
  "reportpage1": {
    "Ccode": "Customer Code",
    "Cname": "Customer Name",
    "NTitle1": "Arrangement",
    "NTitle2": "Estimated Containers",
    "NTitle3": "Confirmed Orders QTY",
    "NTitle4": "Total Amount (USD)",
    "NTitle5": "Confirmed Containers",
    "VPname": "VP Name",
    "title1": "This month invoice amount",
    "title2": "Invoice amount of the same period last year",
    "title3": "Month Ratio Compare",
    "title4": "Invoice amount Current year",
    "title5": "Prior Year's invoice amount",
    "title6": "Year Ratio Compare"
  },
  "reportpage10": {
    "search": {
      "title1": "Department",
      "title2": "VP/Sales",
      "title3": "Company",
      "title4": "Date"
    },
    "thTitle": {
      "title1": "No",
      "title10": "Last Month Intake Volume($)",
      "title11": "Same Month Last Year Intake CTN",
      "title12": "Same Month Last Year Intake Volume(＄)",
      "title13": "YOY Growth Last Month In Volume(%)",
      "title14": "This Month Intake CTN",
      "title15": "This Month Intake Volume($)",
      "title16": "Order intake in this year CNT",
      "title17": "Order intake in this year $",
      "title18": "YOY Growth This Month In Volume(%)",
      "title19": "This Year Total Intake CTN",
      "title2": "Division",
      "title20": "This Year Total Intake Volume ($)",
      "title21": "Last Year Total Intake CTN",
      "title22": "Last Year Total Intake Volume ($)",
      "title23": "YOY Growth In Total Intake Volume(%)",
      "title3": "VP/Sales",
      "title4": "Customer",
      "title5": "Travel date",
      "title6": "Market",
      "title7": "Container Commitment",
      "title8": "Container Confirm",
      "title9": "Last Month Intake CTN"
    },
    "tips1": "The start date of receipt cannot be later than the end date",
    "tips2": "Invoicing start date cannot be later than end date",
    "tips3": "Only data within half a year can be exported after receiving orders",
    "tips4": "Invoicing can only export data within half a year",
    "fieldA": "Last Quarter Sales\n",
    "fieldB": "First Shipment Date"
  },
  "reportpage11": {
    "search": {
      "title1": "Department",
      "title2": "VP/Sales",
      "title3": "Customer Name",
      "title4": "Date"
    },
    "thTitle": {
      "title1": "No",
      "title10": "Amount",
      "title11": "shiped ctn qty next month",
      "title12": "amount",
      "title2": "Division",
      "title3": "VP/Sales",
      "title4": "Customer",
      "title5": "shipped ctn qtys last month",
      "title6": "amount",
      "title7": "Discount",
      "title8": "commission/salary",
      "title9": "shiped ctn qty this month"
    },
    "tips1": "The start date of receipt cannot be later than the end date",
    "tips2": "Invoicing start date cannot be later than end date",
    "tips3": "Only data within half a year can be exported after receiving orders",
    "tips4": "Invoicing can only export data within half a year"
  },
  "reportpage2": {
    "Ccode": "Customer Code",
    "Cname": "Customer Name",
    "days": "Days",
    "title1": "Insurance Company",
    "title2": "Terms of payment",
    "title3": "Account Receivable",
    "title4": "Overdue Amount",
    "title5": "Last Payment Date",
    "title6": "Last Payment Amount"
  },
  "reportpage4": {
    "Ccode": "Customer Code",
    "ChassisFee": "Chassis Fee",
    "ChassisSplit": "Chassis Split",
    "Cname": "Customer Name",
    "CustomsExam": "CustomsExam",
    "Demurrage": "Demurrage",
    "DropPickUpFee": "Drop & Pick Up Fee",
    "ECD": "Extra Charge for Delivery",
    "OverTimeWaiting": "Over Time Waiting",
    "PrePull": "Pre Pull",
    "Totalcost": "Total additional cost",
    "YardStorage": "Yard Storage"
  },
  "reportpage5": {
    "ECDDTR": "Production and Shipping Performance Analysis",
    "PI": "PI#",
    "actuallyFinishedDate": "Actual Completion Date",
    "amercement": "amercement",
    "between120and150days": "121-150 days",
    "between150and180days": "151-180 days",
    "between15and30days": "16-30 days",
    "between30and60days": "31-60 days",
    "between60and90days": "61-90 days",
    "between90and120days": "91-120 days",
    "closingDate": "CY Closing Date",
    "color": "Color",
    "csr": "CSR",
    "customerCode": "Customer Code",
    "customerName": "Customer Name",
    "customerPO": "Customer PO#",
    "day": "days",
    "dept": "Division",
    "eta": "ETA",
    "etd": "ETD",
    "finishedDay": "Finished Day",
    "finishedGoodsInventoryAgeReport": "Finished Goods Inventory Age Report",
    "finishedGoodsInventoryInformationReport": "SO Status",
    "fob": "FOB",
    "hasSolution": "Solution Available YES/NO ",
    "incoterms": "Trade Term",
    "inventory": "Inventory",
    "lessThan15days": "Less than 15 days",
    "material": "Material",
    "model": "Model",
    "more60Days": "Over 60 days",
    "openingDate": "CY Open Date",
    "orderAmount": "Order Amount",
    "orderWithSO": "Order with SO",
    "orderWithoutSO": "Order without SO",
    "ordersWithSO": "Orders with SO",
    "ordersWithoutSO": "Orders without SO",
    "over180days": "Over 180 days",
    "qty": "Order QTY",
    "so": "SO#",
    "soFalse": "Stock without SO",
    "soStatus": "SO Status",
    "soTrue": "Have SO",
    "solution": "Solution",
    "spec": "Spec.",
    "stockDays": "Stock Days",
    "stockDaysScope": "Stock Days Range",
    "totalOrders": "Total Orders",
    "tradeTerms": "Trade Terms",
    "tradeTerms2": "2/Trade Terms",
    "unit": "Unit：CTNS",
    "vbeln": "PI#",
    "viewScope": "View Scope",
    "vpAssistance": "VP Assistant",
    "zjsi": "SI Closing Date"
  },
  "reportpage8_7": {
    "Cname": "Customer Name",
    "Country": "Country/Area",
    "TradeTerms1": "1/Trade Terms",
    "TradeTerms2": "2/Trade Terms",
    "code": "Code",
    "ctn": "CTN in warehouse(40HQ)",
    "dept": "Dept.",
    "name": "Name",
    "title0": "Cover Number",
    "title1": "Model Number",
    "title2": "This Month Amount",
    "title3": "This Month Ratio",
    "title4": "Prior Year Month Amount",
    "title5": "Current Year Ratio",
    "title6": "Month Ratio Compare",
    "title7": "Current Year Amount",
    "title8": "Prior Year Amount",
    "title9": "Year Ratio Compare"
  },
  "reportpage9": {
    "search": {
      "title1": "Department",
      "title2": "Order Recived Date ",
      "title3": "Factory",
      "title4": "Invoicing Date",
      "title5": "Cover"
    },
    "thTitle": {
      "title1": "Customer Code",
      "title2": "Customer Name",
      "title3": "VP",
      "title4": "Sales",
      "title5": "Sales Dept",
      "title6": "Brand"
    },
    "tips1": "The start date of receipt cannot be later than the end date",
    "tips2": "Invoicing start date cannot be later than end date",
    "tips3": "Only data within half a year can be exported after receiving orders",
    "tips4": "Invoicing can only export data within half a year",
    "tips5": "The cubes of the container must be within the range of 2,000 ft³ to 2,350 ft³",
    "tips6": "The cubes of the container must be within the range of 56.63 m³ to 66.54 m³",
    "tips7": "The order includes multiple colors for the same model, please check",
    "tips8": "Cannot send"
  },
  "resetPassword": {
    "confirmReset": "Confirm reset password?",
    "pleaseEnterUsername": "Please enter username",
    "reset": "Reset",
    "resetSuccess": "Reset success",
    "tip": "Tip",
    "username": "username",
    "tips": "Are you sure you want to reset the password for \"{t}\"?"
  },
  "saleBudget": {
    "Account": "Account",
    "apaSalesBudget": "Sales Budget For Asia-Pacific And Australia",
    "year": "Year",
    "yearPlaceholder": "Select Year",
    "Baddress": "ADDRESS",
    "CDR": "Customer Discount Rate",
    "CDRD": "Customer Discount Rate Details",
    "Tariff": "Tariff",
    "VPdiscountRate": "VP Discount Rate",
    "ae": "Abnormal Expenses",
    "bac": "Beneficiary A/C#",
    "bbi": "BENEFICIARY'S BANK INFORMATION",
    "bc": "Buyer Contracts",
    "bi": "BUYRER INFORMATION",
    "bn": "Bank Name",
    "budgetLabel": "Budget",
    "budgetQuota": "Budget Quota",
    "budgetYear": "Budget Year",
    "bv": "Business Volume",
    "cas": "Customer annual sales",
    "cass": "Customer Approx Sofa Sales",
    "cfab": "Contact for Appointment Bookings",
    "cfo": "Controller CFO Information",
    "ci": "CUSTOMER BASIC INFORMATION",
    "clci": "CUSTOMER LOGISTICS CONTACT INFORMATION",
    "cpu": "Customer Price(USD) ",
    "crsim": "Customer Retail sales ",
    "customerCode": "Customer Code",
    "customerName": "Customer Name",
    "customerType": "Customer Type",
    "dcn": "DBA Company Name",
    "de": "Division Expenses",
    "dr": "Discount Rate",
    "fr": "Free Replacement",
    "fsp": "FOB Standard Price",
    "fti": "Federal Tax ID",
    "mfs": "Main Furniture Suppliers",
    "month": "Month",
    "monthMap": {
      "10": "Oct.",
      "11": "Nov.",
      "12": "Dec.",
      "01": "Jan.",
      "02": "Feb.",
      "03": "Mar.",
      "04": "Apr.",
      "05": "May",
      "06": "Jun.",
      "07": "Jul.",
      "08": "Aug.",
      "09": "Sep."
    },
    "nbv": "Net Business Volume",
    "nolp": "Name Of Legal Peron",
    "oftf": "Ocean Freight + Trucking Fee",
    "osic": "On Site Inspection Contact",
    "project": "Project",
    "qc": "Quality Control Contact",
    "salesAmount": "Sales Amount(USD)",
    "salesBudget": "Sales Budget",
    "sta": "Ship to Address",
    "summary": "Summary",
    "tdr": "Total Discount Rate",
    "tm": "Travel Expenses",
    "tnr": "Total Net Revenue",
    "usaCountry": "Country/State",
    "vpSales": "VP/Sales",
    "wm": "Warehouse Manager",
    "yoyGrowth": "Growth Ratio",
    "ysbr": "Year Budget Achieve Ratio%",
    "ysdrRate": "Budget Growth Ratio%"
  },
  "timeOptions": {
    "endPlaceholder": "End Date",
    "oneMonthAgo": "A Month Ago",
    "sixMonthAgo": "]Six Months Ago",
    "startPlaceholder": "Start Date",
    "threeMonthAgo": "Three Months Ago",
    "today": "Today"
  },
  "travel": {
    "TravelSchedule": "Travel Schedule",
    "agree": "Agree",
    "approval": "Approval",
    "approvalComments": "Approval Comments",
    "approvalDataExists": "Approval Data Exists",
    "approvalList": "Approval List",
    "approvalProcessPlanning": "Approval Process Planning",
    "approvalStatus": "Approval Status",
    "approved": "Approved",
    "approverComments": "Approver's Comments",
    "businessCard": "Business Card",
    "company": "Competitors",
    "competitorStyle": "Competitors Model Name",
    "competitors": "Competitors",
    "country": "Country/Area",
    "customerDetail": "Customer Detail",
    "customerName": "Customer Name",
    "customerType": "Customer Type",
    "date": "Date",
    "detail": "Detail",
    "exportReport": "Export Report",
    "face": "In Person",
    "followUp": "Pending Follow Up",
    "fullAddress": "Full Address",
    "generalManagerApproval": "General Manager's Approval",
    "img": "Travel Image",
    "location": "Location",
    "month": "Month",
    "mwStyle": "MW Model Num.",
    "new": "New Customer",
    "old": "Existing Customers",
    "nopwaoabt": "Currently Traveling",
    "notBeEmpty": "Cannot Be Empty",
    "orders": "Orders",
    "other": "Other",
    "payment": "payment",
    "pendingApproval": "Pending Approval",
    "pendingReview": "Pending Review",
    "pendingSubmission": "pending Submission",
    "placementNum": "Competitors Model QTY",
    "prospectVisitTargets": "Prospect Visit Targets",
    "ptnopt": "Planned to Travel",
    "quality": "Quality",
    "recall": "Recall",
    "reject": "Return to Previous Level",
    "reject1": "Return to Business Unit",
    "rejected": "Rejected",
    "remark": "Remark",
    "retailPrice": "Retail Price",
    "reviewComments": "Review Comments",
    "scheduledEndTime": "Scheduled End Time",
    "scheduledStartTime": "Scheduled Start Time",
    "shipping": "shipping",
    "shop": "Store Visit",
    "state": "Region",
    "storeNum": "Store QTY",
    "storeStyle": "Model QTY",
    "submitForApproval": "Submit For Approval",
    "tDays": "Travel Days",
    "tel": "Tel",
    "tips": "Please select at least one VP/Sales!",
    "tips1": "Please select only one VP/Sales!",
    "title": "Travel",
    "tnop": "Total Headcount",
    "tnopwhnt": "Not Traveling",
    "travelName": "VP/SALES Name",
    "travelPlan": "Travel Plan",
    "travelVPAssistant": "Travel VP Assistant",
    "travelVPSales": "Travel VP/Sales",
    "tvn": "Visited Customers",
    "view": "View",
    "viewCompetitor": "View Competitor",
    "visitCustomer": "Visit Customer",
    "visitMode": "Visit Mode",
    "visitResult": "Visit Result",
    "visitResults": "Visit Results",
    "visitTime": "Visit Time",
    "vpAssistant": "VP Assistant",
    "year": "Year"
  },
  "x": "Regular Customer",
  "types": "Types",
  "uploadDocuments": "Upload Documents",
  "util": {
    "CopySuccess": "Copy Success",
    "ImageAddedtoEmail": "Image Added To Email",
    "ImageAlreadyInEmail": "Image Already In Email",
    "disableEmail": "Email Sending Prohibited",
    "disableSap": "SAP Transfer Prohibited"
  },
  "lineup": {
    "template": "Export Budget Template"
  },
  "modelDetail": {
    "pd": "Product Description"
  },
  "ex": {
    "businessCard": "Business Card",
    "attachment": "Attachment"
  },
  "qs": {
    "cs": "Combination Specification"
  },
  "commitments": {
    "detailInfo": "Details of Committment Orders",
    "exportOrderUpdateInfo": "Export Committment Orders Update Info",
    "summaryInfo": "Summary of Committment Orders"
  },
  "tips": {
    "resp1": "File format error: Only files in .pptx format are supported!"
  },
  "export": {
    "labelType": "Export Delivery Analysis for Sales",
    "labelTypes": "Export Customer Delivery Date Analysis"
  },
  "qsReport": {
    "customerCode": "Customer Code",
    "customerName": "Customer Name",
    "intake": "Intake",
    "shipment": "Shipment",
    "yoyI": "Intake YoY Growth",
    "yoyS": "Shipment YoY Growth",
    "IS": "Intake/Shipment",
    "TIS": "Total Intake/Shipment"
  },
  "salesAnalysis": {
    "model": "Model",
    "floor": "Floor Display",
    "color": "Cover",
    "catagory": "Catagory",
    "pb": "Leather/Fabric",
    "xse": "Current Period and Last Period",
    "orderInTakeNum": "Order Intake",
    "threeMonths": "Order Intake for next three months",
    "growth": "Growth Ratio%",
    "Accumulated": "Total Accumulated"
  }
};
